// extracted by mini-css-extract-plugin
export default {"formContainer":"formContainer__YWYxZ","inputsWrapper":"inputsWrapper__MzJmY","verticalStack":"verticalStack__MzYzN","ctaWrapper":"ctaWrapper__MTIyO"};